export default "__VITE_ASSET__28426faf__"